import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { CommonModule } from '@angular/common';
import { UntypedFormGroup, FormControl, UntypedFormBuilder, FormArray, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppSettingsService } from '../services/appsettings.service';
import { AppSettings } from '../app.settings';
import { TranslateService } from '@ngx-translate/core';



@Component({
    selector: 'app-login-view',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    model: any = {};
    loading = false;
    returnUrl: string;
    emailid;
    formdata;
    loginForm: UntypedFormGroup;
    isCompleted: true;
    showErrorMessage: boolean;
    deviceInfo = null;
    private settings: AppSettings;
    enrollURL: string;

    LoginForm: UntypedFormGroup;

    


    constructor(private route: ActivatedRoute,
                private router: Router,
                private formBuilder: UntypedFormBuilder,
                private deviceService: DeviceDetectorService,
                private appSettingsService: AppSettingsService,
                private authenticationService: AuthenticationService,private translate_login: TranslateService
                ) { 

                  this.appSettingsService.getSettings().subscribe(settings => this.settings = settings,
                    () => null,
                    () => {
                      this.enrollURL = this.settings.enrollServer;
                    });

                    //md add
                    translate_login.addLangs(['en']);//, 'nl','es','de'
                    translate_login.setDefaultLang('en');



                }
                switchLang(lang: string) {
                  this.translate_login.use(lang);
                }

    ngOnInit() {
        this.loading = false;

//  window.location.reload();


        const logoutclicked = localStorage.getItem('refreshClicked');
        if (logoutclicked === 'true') {
          localStorage.setItem('refreshClicked', 'false');
          window.location.reload();
        }

        this.authenticationService.logout();

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/home/tabs';

        this.initForm();

    }




    initForm() {

        this.LoginForm = this.formBuilder.group({
          LoginPage: this.formBuilder.group({
            username: ['', [Validators.required]],
            password: ['', [Validators.required]]
          }),
            ThankYouPage: this.formBuilder.group({
            email: ['', [Validators.required]]
          })
        });
      }




     login(fdata) {

      if (fdata.username === '' || fdata.password === '') {

            Object.keys(this.LoginForm.controls.LoginPage.value).forEach(field => {
                const control = this.LoginForm.controls.LoginPage.get(field);
                control.setValidators([Validators.required]);
                control.markAsTouched();
                control.updateValueAndValidity();
              });
        }


      this.showErrorMessage = false;

      if (this.LoginForm.get('LoginPage').valid) {

        this.loading = true;
        this.authenticationService.login(fdata.username, fdata.password)
            .subscribe(
              async result => {

                const user = result;
                this.loading = false;
                const apptype =   localStorage.getItem('enroll_type');
                const id =  localStorage.getItem('id');


                localStorage.setItem('currentUser', JSON.stringify(user));
               // console.log('loginTest', JSON.parse(localStorage.getItem('currentUser')).token);


                if (result === 'Success') {

                  this.deviceInfo = this.deviceService.getDeviceInfo();
                  const isMobile = this.deviceService.isMobile();
                  const isTablet = this.deviceService.isTablet();
                  const isDesktopDevice = this.deviceService.isDesktop();

                  const post = {
                    applicationName: 'LHCSAApplication',
                    osName: this.deviceInfo.os,
                    osVersion: this.deviceInfo.os_version,
                    browserName: this.deviceInfo.browser,
                    browserVersion: this.deviceInfo.browser_version,
                    isMobile: this.deviceService.isMobile(),
                    isTablet: this.deviceService.isTablet(),
                    isDesktopDevice: this.deviceService.isDesktop(),
                    userName: fdata.username
                  };


                  setTimeout(() => {

                    (((this.authenticationService.captureDeviceInfo(post))))
                    .subscribe(
                      devresult => {
                      });
                  }, 200);




                  this.router.navigate(['/wizard']);
                   } else if (result === 'AlreadyCompletedApplication') {
                    this.router.navigate(['/thankyou']);
                   } else if (result.results === 'Invalid credentials') {
                    this.showErrorMessage = true;
                   }

                    // console.log('logindata1', user);

                   /* if (user && user.token && user.token !== 'Invalid username or password' && user.token !== 'Error') {

                        localStorage.setItem('currentUser', JSON.stringify(user));

                        this.router.navigate([this.returnUrl]);
                    } else if (user.token === 'Invalid pin') {

                        this.loading = false;
                        alert('Invalid Pin Number');
                        return false;
                    }*/

                },
                error => {
                    this.loading = false;
                    const error1 = error;
                    alert(error1);
                });

          } else {
            // validate all form field

          }



    }



    goForward(stepper: MatStepper) {

        Object.keys(this.LoginForm.controls.LoginPage.value).forEach(field => { // {1}


            const control = this.LoginForm.controls.LoginPage.get(field);            // {2}
            control.clearValidators();
            control.updateValueAndValidity();       // {3}

          });


        stepper.next();
    }



}
